import { GroupOptionType, SelectOptionType } from "@chhjit/react-components";

export const getSelectValue = <T>(
  value: T | null,
  options: (SelectOptionType<T> | GroupOptionType<T>)[],
) => {
  const isGroup = (options as GroupOptionType<T>[]).every((opt) => opt.options);

  const val = isGroup
    ? (options as GroupOptionType<T>[])
        .flatMap((option) => option.options)
        .find((opt) => opt.value === value)
    : (options as SelectOptionType<T>[]).find((opt) => opt.value === value);

  return val || null;
};

export const getSelectOptionValue = <T>(option: SelectOptionType<T> | null) => {
  return option ? option.value : "";
};

export const handleSelectChange =
  (onChange: (val: unknown) => void) =>
  (option: SelectOptionType<unknown> | null) => {
    const value = getSelectOptionValue(option);
    onChange(value);
  };
